import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

export const PageAbout: Definition = {
  contentType: 'PageAbout',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent'
    },
    {
      id: 'benefits',
      name: 'Benefits',
      type: 'Array',
      subType: 'ModuleUsp'
    },
    {
      id: 'introMedia',
      name: 'Intro media',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { resize: true, sizes: imageSizes.columns12_5269, lazy: true }
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'contentBlock1',
      name: 'Content block 1',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns12_52, lazy: true }
    },
    {
      id: 'contentBlock2',
      name: 'Content block 2',
      type: 'BlockGroup',
      subType: 'ModuleUsp'
    },
    {
      id: 'adyenFormula',
      name: 'Adyen formula',
      type: 'BlockCompanyFormula',
      options: { transformShortDescription: false }
    },
    {
      id: 'contentBlock3',
      name: 'Content block 3',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns6_11, lazy: true }
    },
    {
      id: 'locationsTitle',
      name: 'Locations title',
      type: 'Symbol'
    },
    {
      id: 'locationsLink',
      name: 'Locations link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    }
  ]
}

export const PageAboutTeam: Definition = {
  contentType: 'PageAboutTeam',
  fields: [
    {
      id: 'contentBlock',
      name: 'Content block',
      type: 'BlockGroup',
      subType: 'BlockTabContentLazy',
      lazy: true,
      imageOptions: {
        resize: true,
        sizes: {
          small: { width: 272, height: 272, aspectRatio: '1/1' },
          medium: { width: 368, height: 368, aspectRatio: '1/1' },
          large: { width: 368, height: 368, aspectRatio: '1/1' }
        },
        lazy: true
      }
    },
    {
      id: 'backLink',
      name: 'Back link',
      type: 'ModuleNavigationLink'
    }
  ]
}

export const PageCustomers: Definition = {
  contentType: 'PageCustomers',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockLogoBar'
    },
    {
      id: 'quotesGallery',
      name: 'Quotes Gallery',
      type: 'BlockQuoteGroup'
    },
    {
      id: 'contentBlock1',
      name: 'Content Block 1',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns12_52, lazy: true }
    },
    {
      id: 'contentBlock2',
      name: 'Content Block 2',
      type: 'BlockContent'
    },
    {
      id: 'quoteBlock1',
      name: 'Block Quote 1',
      type: 'BlockQuote',
      imageOptions: { resize: true, sizes: imageSizes.columns6_11, lazy: true }
    },
    {
      id: 'logobar1',
      name: 'Logo bar 1',
      type: 'BlockLogoBar'
    },
    {
      id: 'contentBlock3',
      name: 'Content Block 3',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns12_52, lazy: true }
    },
    {
      id: 'logobar2',
      name: 'Logo bar 2',
      type: 'BlockLogoBar'
    },
    {
      id: 'contentBlock4',
      name: 'Content Block 4',
      type: 'BlockContent'
    },
    {
      id: 'quoteBlock2',
      name: 'Block Quote 2',
      type: 'BlockQuote',
      imageOptions: { resize: true, sizes: imageSizes.columns6_11, lazy: true }
    },
    {
      id: 'logobar3',
      name: 'Logo bar 3',
      type: 'BlockLogoBar'
    },
    {
      id: 'contentBlock5',
      name: 'Content Block 5',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns12_52, lazy: true }
    },
    {
      id: 'simpleQuote1',
      name: 'Simple Quote 1',
      type: 'BlockQuote',
      imageOptions: { lazy: true }
    },
    {
      id: 'logobar4',
      name: 'Logo bar 4',
      type: 'BlockLogoBar'
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent',
      localized: true
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCallToAction'
    }
  ]
}

export default {
  PageAbout,
  PageAboutTeam,
  PageCustomers
}
